import ProducersSection from "./sections/ProducersSection";
import ManagersSection from "./sections/ManagersSection";
import TransformersSection from "./sections/TransformersSection";
import CollectivePlansSection from "./sections/CollectivePlansSection";
import PageHeader from "../components/PageHeader/PageHeader";

function Solutions() {
  return (
    <>
      <PageHeader
        eyebrow="Soluciones"
        title="Diseñado para cada actor de la cadena"
        subtitle="EcoRep adapta su propuesta de valor a las necesidades específicas de cada tipo de actor en la cadena de economía circular."
      />

    

      <div id="productores"><ProducersSection /></div>
      <div id="gestores"><ManagersSection /></div>
      <div id="transformadores"><TransformersSection /></div>
      <div id="planes-colectivos"><CollectivePlansSection /></div>
    </>
  );
}

export default Solutions;
